import { Repuesto } from "@/domain/entities/repuesto";
import { IRepuestoRepository } from "@/domain/repositories/IRepuestoRepository";

export class GetRepuestoUseCase {
  constructor(
    private readonly RepuestoRepository: IRepuestoRepository
  ) {}

  async execute(
    id: string
  ): Promise<Repuesto[]> {
    return this.RepuestoRepository.findById(id);
  }
}
